<div class="kt-wrap">
  <div class="kt-header">
    <h1>Kiosk tablets</h1>
    <p class="sub">The Frigg Kiosk tablets at schools. Each reports every minute; updated here every 30 seconds.</p>
  </div>

  <p class="kt-msg ok" *ngIf="message">{{ message }}</p>
  <p class="kt-msg err" *ngIf="error">{{ error }}</p>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
    <span>Loading tablets…</span>
  </div>

  <div class="empty" *ngIf="!loading && !error && tablets.length === 0">
    No tablet has reported yet. Tablets report from app version 2.26.
  </div>

  <div class="kt-list">
    <div class="kt-card" *ngFor="let t of tablets">
      <div class="kt-top">
        <div>
          <div class="kt-name">{{ t.machineName || t.systemId }}</div>
          <div class="kt-meta">{{ modelText(t) }} · app {{ t.version || '?' }}<span *ngIf="t.build"> ({{ t.build }})</span></div>
        </div>
        <span class="kt-state" [ngClass]="stateClass(t)">{{ stateText(t) }}</span>
      </div>

      <div class="kt-facts">
        <span>Last seen: <strong>{{ t.lastSeen ? (t.lastSeen | date:'dd.MM HH:mm:ss') : 'never' }}</strong></span>
        <span>Card payment: <strong>{{ t.payEnabled ? 'ready' : 'not ready' }}</strong></span>
        <span>Lock: <strong>{{ t.lockMode === 'locked' ? 'full lock' : t.lockMode === 'pinned' ? 'pinned only' : 'off' }}</strong></span>
      </div>

      <p class="kt-warn" *ngIf="t.screenLock">
        Screen lock (PIN) is on: after <strong>Restart tablet</strong> it waits for the PIN and the kiosk does not
        start by itself. Use <strong>Restart app</strong>, or remove the PIN on the tablet
        (Lock screen → Screen lock type → None).
      </p>

      <p class="kt-pending" *ngIf="t.command">
        Waiting for the tablet: {{ t.command.type === 'reboot' ? 'restart tablet' : 'restart app' }}
        (sent {{ t.command.at | date:'HH:mm:ss' }})
      </p>

      <div class="kt-actions">
        <button mat-stroked-button [disabled]="sending[t.deviceId]" (click)="send(t, 'reload')">
          {{ confirming[t.deviceId] === 'reload' ? 'Click again to restart the app' : 'Restart app' }}
        </button>
        <button mat-stroked-button color="warn" [disabled]="sending[t.deviceId]" (click)="send(t, 'reboot')">
          {{ confirming[t.deviceId] === 'reboot' ? 'Click again to restart the tablet' : 'Restart tablet' }}
        </button>
      </div>
      <p class="kt-hint" *ngIf="silent(t)">
        The tablet is not reporting, so a restart only runs once it is back online and the app is running.
        If it stays silent: hold side button + volume down for 7 s on the tablet.
      </p>
    </div>
  </div>
</div>
